import React, { useEffect, useState } from "react";
import { AlertTriangle, X } from "lucide-react";
import { getImpersonation, setImpersonation } from "@/lib/api";

/** Persistent amber banner shown at the top of the app when platform_owner
 *  is viewing another tenant's workspace via X-Impersonate-Company. */
export default function ImpersonationBanner() {
    const [imp, setImp] = useState(getImpersonation());
    useEffect(() => {
        const on = () => setImp(getImpersonation());
        window.addEventListener("wfos:impersonation-change", on);
        window.addEventListener("storage", on);
        return () => {
            window.removeEventListener("wfos:impersonation-change", on);
            window.removeEventListener("storage", on);
        };
    }, []);
    if (!imp) return null;
    return (
        <div
            data-testid="impersonation-banner"
            className="flex-shrink-0 flex items-center justify-between gap-3 px-6 py-2 bg-amber-100 border-b border-amber-300 text-amber-900 text-sm"
        >
            <div className="flex items-center gap-2 min-w-0">
                <AlertTriangle className="w-4 h-4 flex-shrink-0" strokeWidth={2} />
                <span className="truncate">
                    You are viewing <b>{imp.company_name || "another workspace"}</b> as Platform Owner. All views are <b>READ-ONLY</b>.
                </span>
            </div>
            <button
                onClick={() => {
                    setImpersonation(null);
                    setTimeout(() => window.location.reload(), 50);
                }}
                data-testid="impersonation-exit"
                className="inline-flex items-center gap-1 rounded-md border border-amber-400 bg-white px-2 h-7 text-xs font-medium text-amber-900 hover:bg-amber-50"
            >
                <X className="w-3 h-3" strokeWidth={2} /> Exit impersonation
            </button>
        </div>
    );
}
